import { Grid, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { MentorTipIcon } from "../../../shared/icons/gamePlan";
import { useStyles } from "./meet-your-mentor.styles";

interface MeetYourMentorProps {
  educatorName: string;
  onExpandClick?: () => void;
  expanded: boolean;
}

function MeetYourMentor({
  educatorName,
  onExpandClick,
  expanded,
}: MeetYourMentorProps) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item container md={4} justifyContent="center">
        <MentorTipIcon width={74} height={74} />
      </Grid>
      <Grid item container md={8}>
        <Grid item md={12}>
          <Typography className={classes.subtitle}>I&lsquo;m</Typography>
        </Grid>
        <Grid item container md={12} alignItems="center">
          <Typography className={classes.title}>{educatorName}</Typography>
          <ExpandMoreIcon
            className={
              !expanded ? classes.contractedIcon : classes.expandedIcon
            }
            onClick={onExpandClick}
          />
        </Grid>
        <Grid item md={12}>
          <Typography className={classes.subtitle}>Your mentor</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MeetYourMentor;
